import { Panel } from 'rsuite';
import { User } from '~/types/User';
import defaultUserPhoto from '~/user-solid.svg';

import styles from './UserPanel.module.less';

// Inlined rather than pulled from an icon package: this panel is rendered through
// ReactDOMServer.renderToStaticMarkup into a SweetAlert body, and @rsuite/icons is only
// present transitively. currentColor keeps it in step with the label it sits next to.
const TicketIcon = () => (
	<svg
		className={styles['ticket-icon']}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
		focusable="false"
	>
		<path d="M4 8.5V7a1.5 1.5 0 0 1 1.5-1.5h13A1.5 1.5 0 0 1 20 7v1.5a2.5 2.5 0 0 0 0 5V17a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 17v-3.5a2.5 2.5 0 0 0 0-5Z" />
		<path d="M14 6v12" strokeDasharray="1.5 2.5" />
	</svg>
);

const ticketLabel = (user: User) =>
	typeof user.sequenceNumber === 'number'
		? `${user.ticketType} #${user.sequenceNumber}`
		: user.ticketType;

export const UserPanel = ({ user }: { user: User }) => (
	<>
		<Panel shaded bodyFill className={styles['user-panel']}>
			<img
				className={styles.avatar}
				src={user.photo && user.photo != "" ? user.photo : defaultUserPhoto }
				alt="Avatar"
				height="100"
			/>
			<div className={styles.name}>
				{ `${user.name ?? ''} ${user.lastName ?? ''}`.trim() }
			</div>
			{ user.ticketType && (
				<div className={styles['ticket-type']}>
					<TicketIcon />
					<span>{ ticketLabel(user) }</span>
				</div>
			)}
		</Panel>
	</>
);
